import Joi from "joi";

export const incidentSchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
  stepsTaken: Joi.string().min(2).label("Steps Taken"),
  dateTime: Joi.date().required().label("Time"),
});
